<template>
  <div :class="classes">
      <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" ref="table"  :isAddPageToRouter="true"
      :isOutside="isOutside" v-loading="loading" layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 30, 50, 200]">
      <wt-table :labels="tableLabel" :list="tableData" ref="wtTable" :max-height="tableMaxHeight">
          <slot/>
      </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
import { refundTableLabel } from '../../goods-order-options'
// 组件class前缀
const prefixCls = 'pt-refund-table'

export default {
  name: 'pt-refund-table',
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    currentPage: {
      type: Number,
      default: 0
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      tableLabel: refundTableLabel,
      tableMaxHeight: null
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      this.$emit('refundList', page, next, size)
    },
    showReTry () {
      this.$refs.table.showReTry()
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.tableMaxHeight = window.innerHeight - this.$refs.wtTable.$el.offsetTop - 280

      // 监听窗口大小变化
      let self = this
      window.onresize = function () {
        self.tableMaxHeight = window.innerHeight - self.$refs.wtTable.$el.offsetTop - 280
      }
    })
    // this.$refs.wtTable.$el.offsetTop：表格距离浏览器的高度
    // 150表示你想要调整的表格距离底部的高度
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
